import "../scss/groups/_hot-zone.scss"

import {HotZone} from './components/HotZone/HotZone.js';

const hotZoneContainer = [...document.querySelectorAll('[data-hot-zone]')];
if (hotZoneContainer.length) {
    HotZone(hotZoneContainer)
}
